import * as React from 'react';

import { useUnit } from 'effector-react';
import { Navigate } from 'react-router-dom';

import { ChangePasswordForm } from '../../components/Forms/ChangePassword';
import { Modal } from '../../components/Modal';
import { User$ } from '../../effector/user';
import { PAGE_ROOT } from '../Routes';

export const ChangePassword: React.FC = () => {
  const user = useUnit(User$);

  if (user) {
    return <Navigate replace to={PAGE_ROOT} />;
  }

  return (
    <Modal
      isOpen={true}
      onRequestClose={() => {
        console.log('close');
      }}
      title="Смена пароля"
    >
      <ChangePasswordForm />
    </Modal>
  );
};
